import withHandlers from 'recompose/withHandlers';
import withProps from 'recompose/withProps';
import compose from 'recompose/compose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import Joi from 'joi-full';

import { getShopBarbers } from '../reducers';
import fetchOnUpdate from '../../../common/decorators/fetchOnUpdate';
import {
  saveBarberConnectedAccount,
  saveShopConnectedAccount,
} from '../actions';
import withNotifications from '../../../common/withNotifications';
import { syncValidateData } from '../../../common/validator';
import PaymentSettings from '../components/PaymentSettings';
import {
  getBarberBankAccount,
  getShopBankAccount,
} from '../../../main/settings/actions';
import { selectManagedAccountId } from '../../../main/settings/selectors';

const schema = {
  managedAccountId: Joi.string().required(),
};

const POS_FORM = 'posForm';

const form = reduxForm({
  form: POS_FORM,
  enableReinitialize: true,
  validate: values => syncValidateData(values, schema),
  onSubmitSuccess: (_values, _dispatch, props) => {
    props.addNotification({
      title: 'Success',
      level: 'success',
      message: 'Changes saved successfully',
    });
  },
});

const addHandlers = withHandlers({
  onSubmit: props => (data) => {
    if (props.barberId) {
      return props.saveBarberConnectedAccount(props.barberId, data);
    }

    return props.saveShopConnectedAccount(props.shopId, data);
  },
});

const prepareFetchParams = withProps(props => ({
  params: {
    shopId: props.shopId,
    barberId: props.barberId,
  },
  actions: {
    shopFetch: props.getShopBankAccount,
    barberFetch: props.getBarberBankAccount,
  },
}));

const fetch = fetchOnUpdate(['shopId', 'barberId'], (params, actions) => {
  if (params.barberId) {
    return actions.barberFetch(params.barberId);
  }
  return actions.shopFetch(params.shopId);
});

export default compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      shopId: ownProps.params.id,
      barberId: ownProps.params.barberId,
      barbers: getShopBarbers(state, ownProps.params.id),
      initialValues: {
        managedAccountId: selectManagedAccountId(state),
      },
    }),
    {
      getShopBankAccount,
      getBarberBankAccount,
      saveShopConnectedAccount,
      saveBarberConnectedAccount,
    },
  ),
  withNotifications,
  addHandlers,
  form,
  prepareFetchParams,
  fetch,
)(PaymentSettings);
